import React from "react"
import PropTypes from "prop-types"
import { useTranslation } from "react-i18next"

const BuildingIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12 2L2 7v1h20V7L12 2zM4 10v10h3v-6h2v6h6v-6h2v6h3V10H4zm8-6.5L18.5 7h-13L12 3.5z" />
  </svg>
)

const OrganizationItem = ({ organization, isActive, onClick, product }) => {
  const { t } = useTranslation()
  const { expired } = organization

  return (
    <button
      className={`pnav-org pnav-org--${product}${isActive ? " pnav-org--active" : ""}${expired ? " pnav-org--expired" : ""}`}
      onClick={onClick}
      type="button"
    >
      <span className="pnav-org__icon">
        <BuildingIcon />
      </span>
      <span className="pnav-org__name">
        {organization.name}
        {expired && ` ${t("common:navigation.expired_suffix")}`}
      </span>
    </button>
  )
}

OrganizationItem.propTypes = {
  organization: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string.isRequired,
    expired: PropTypes.bool,
  }).isRequired,
  isActive: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  product: PropTypes.oneOf(["corporate", "provider"]).isRequired,
}

OrganizationItem.defaultProps = {
  isActive: false,
}

export default OrganizationItem
